// The backend owns text interpretation for display, booking and learning.
// Retain a fallback while older backend instances are being replaced.
export function bankTransactionLabel(transaction) {
  return transaction?.display_description || transaction?.description || transaction?.reference || '';
}

// Booking date is the bank ledger date. Keep transaction/value dates as facts.
export function bankTransactionDate(transaction) {
  return transaction?.booking_date || transaction?.transaction_date || '';
}

export function bankPaymentMessage(transaction) {
  // A null message from the new contract means it is genuinely absent. Do not
  // fall back to display_description, which might contain only a recipient.
  if (Object.prototype.hasOwnProperty.call(transaction || {}, 'payment_message')) {
    return transaction.payment_message || '';
  }
  return bankTransactionLabel(transaction);
}

export function bankCounterpartyLabel(transaction) {
  const amount = Number(transaction?.amount);
  return amount < 0 ? 'Mottagare' : amount > 0 ? 'Avsändare' : 'Motpart';
}

// Facts worth showing NEXT TO the headline: present, and not what the
// headline already says. The list and the booking modal use this; the
// drawer shows every fact with its source instead.
export function bankSecondaryFacts(transaction) {
  const headline = bankTransactionLabel(transaction).trim().toLowerCase();
  const differs = value => value && String(value).trim().toLowerCase() !== headline;
  return [
    { label: bankCounterpartyLabel(transaction), value: transaction?.counterparty_name },
    { label: 'Transaktionstyp', value: transaction?.transaction_type },
  ].filter(fact => differs(fact.value));
}

// Both are proposals; the page's own vocabulary is koppla (link to an existing
// verifikat) vs bokföra (create one).
export function bankSuggestionKind(strategy) {
  if (strategy === 'verification') return 'Kopplingsförslag';
  if (['history', 'llm', 'rule'].includes(strategy)) return 'Bokföringsförslag';
  return null;
}

export function bankTextSourceLabel(source) {
  return { csv: 'CSV-fil', psd2_feed: 'Bankkoppling', camt: 'Bankfil', legacy: 'Tidigare import' }[source] || '';
}
